export const costs = [
  'Sleepless nights searching for ways to translate complex nuclear concepts into language your students can understand.',
  "Improvised classes because you couldn't find clear, ready-to-use materials in time.",
  "Disconnected students who don't see how nuclear energy connects to their futures, careers, or global energy challenges.",
  "Awkward silences when a student asks about radiation safety or nuclear waste and you don't have a clear answer.",
  'Weekends lost building lesson plans, nuclear energy projects, and assessments from scratch over and over.',
  'Uncertainty about how to teach nuclear science, safety, environmental responsibility, or critical thinking about nuclear energy without adequate resources.',
];
